import React from 'react';
import { Col, Row, Container } from 'react-bootstrap';

import { Odom } from '../../HomePage/components/Highlights';
import chatBubble from '../../../assets/images/leadersForStandardsAndSolutions/chatBubble.png';
import bluePhone from '../../../assets/images/leadersForStandardsAndSolutions/bluePhone.png';

const CallHighlights = () => (
  <Container>
    <Row style={{paddingTop: 30}}>
      <Col  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 30}}>
        <div style={{
          width: 300,
          height: 300,
          borderRadius: '50%',
          backgroundColor: '#FDF7E0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // marginBottom: 30
        }}>
          <div style={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 28
          }}>
            <img
              src={chatBubble}
              width="56px"
              height="56px"
              alt=""
            />
          </div>
          <div style={{
            margin: 25,
            marginTop: 32,
            width: 260,
            height: 260,
            borderRadius: 130,
            // backgroundColor: '#FDF7E0',
            display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',
            flexDirection: 'column',
            fontFamily: '',
            padding: 16,
            paddingTop: 30,
          }}>
            <div style={{ height: 72 }}>
              <Odom number={68} text="%" odomStyle={{
                fontSize: 60,
                fontFamily: 'montserrat bold',
                fontWeight: 'bold',
                color: '#1B526D',
                marginTop: 0
              }}
                textStyle={{
                  fontSize: 60,
                  fontFamily: 'montserrat bold',
                  fontWeight: 'bold',
                  color: '#1B526D',
                  marginTop: 32
                }}
              />
            </div>
            <div style={{
              fontSize: 16,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#8A9D76',
              textAlign: 'center'
            }}>
              of brokers spent at least <span style={{ color: '#48604C', fontSize: 20, lineHeight: 1 }}>1 hour a day</span> answering <span style={{ color: '#48604C' }}>customers' billing questions</span>
            </div>
            <div style={{ textAlign: 'center', fontFamily: 'montserrat medium' }}>
              Source: CSIO Broker<br /> survey
            </div>
          </div >
        </div>
      </Col>
      <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 30}}>
        <div style={{
          width: 300,
          height: 300,
          borderRadius: '50%',
          backgroundColor: '#DCE1CF',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 30
        }}>
          <div style={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 20
          }}>
            <img
              src={bluePhone}
              width="56px"
              height="56px"
              alt=""
            />
          </div>
          <div style={{
            margin: 25,
            marginTop: 32,
            width: 260,
            height: 260,
            borderRadius: 130,
            // backgroundColor: '#DCE1CF',
            display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',
            flexDirection: 'column',
            fontFamily: '',
            padding: 16,
            paddingTop: 45,
          }}>
            <div style={{ height: 72 }}>
              <Odom number={66} text="%" odomStyle={{
                fontSize: 60,
                fontFamily: 'montserrat bold',
                fontWeight: 'bold',
                color: '#1B526D',
                marginTop: 0
              }}
                textStyle={{
                  fontSize: 60,
                  fontFamily: 'montserrat bold',
                  fontWeight: 'bold',
                  color: '#1B526D',
                  marginTop: 32
                }}
              />
            </div>
            <div style={{
              fontSize: 16,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1C1F3D',
              textAlign: 'center'
            }}>
              were making at least <span style={{ color: '#1B526D', fontSize: 20, lineHeight: 1 }}>1 claims-related call</span> to an insurer every day
            </div>
            <div style={{ textAlign: 'center', fontFamily: 'montserrat medium' }}>
              Source: CSIO Broker<br /> survey
            </div>
          </div >
        </div>
      </Col>
    </Row>
  </Container>
)

export default CallHighlights;
